// cbInsights api
import loadCbInsightsBusinessRelationshipsApi from '../../cbInsights/api/loadBusinessRelationships.api.cbInsights';
import loadCbInsightsDealsApi from '../../cbInsights/api/loadDeals.api.cbInsights';
import loadCbInsightsOrganizationApi from '../../cbInsights/api/loadOrganization.api.cbInsights';
import loadCbInsightsPeopleApi from '../../cbInsights/api/loadPeople.api.cbInsights';

// creditSafe api
import loadCorporateHierarchyApi from '../../creditSafe/api/loadCorporateHierarchy.api.creditSafe';
import loadCreditSafeFinancialsApi from '../../creditSafe/api/loadFinancials.api.creditSafe';

// data services
import loadAndAttachAsyncJsonToObjectService from '../../data/services/loadAndAttachAsyncJsonToObject.service.data';

// financial mocks
import ebf2401ae39e41789cd94788216d3f43FinancialImage from '../../financial/mock/ebf2401ae39e41789cd94788216d3f43.mock.financial.jpg';
import ebf2401ae39e41789cd94788216d3f43FinancialJson from '../../financial/mock/ebf2401ae39e41789cd94788216d3f43.mock.financial.json';

// firmographic api
import getFirmographicsBySupplierId from '../../firmographic/api/getBySupplierId.api.firmographic';

// supplier api
import getSupplierDashboardApi from '../../supplier/api/getDashboard.api.supplier';

// supplier lib
import getCompanyId from '../../supplier/lib/getCompanyId.lib.supplier';

// tag services
import getCompanyTagsService from '../../tag/services/getCompanyTags.service.tag';

// tenant api
import getHaloScoresApi from '../../tenant/api/getHaloScores.api.tenant';

const getByIdApi = async ({companyId}) =>
  new Promise(async (resolve, reject) => {
    try {
      const [dashboardData, supplierHaloScores] = await Promise.all([
        getSupplierDashboardApi(companyId),
        getHaloScoresApi(companyId),
      ]);

      const companyWithoutTags = {
        ...dashboardData,
        CompanyId: dashboardData.CompanyId,
        weightedHaloScores: supplierHaloScores,
      };

      const {data: tags} = await getCompanyTagsService({
        companyId: companyWithoutTags.CompanyId,
      });

      const company = {
        ...companyWithoutTags,
        tags,
      };

      const haloCompanyId = getCompanyId(company);

      if (!company) return reject('Not found');
      const companyWithLoadedData = await loadAndAttachAsyncJsonToObjectService(
        {
          company,
          dataObject: {
            corporateHierarchy: loadCorporateHierarchyApi(haloCompanyId),
            financials: loadCreditSafeFinancialsApi(haloCompanyId),
            firmographic: getFirmographicsBySupplierId(getCompanyId(company)),
          },
        }
      );

      const cbInsights = await loadAndAttachAsyncJsonToObjectService({
        company: {},
        dataObject: {
          businessRelationships:
            loadCbInsightsBusinessRelationshipsApi(haloCompanyId),
          deals: loadCbInsightsDealsApi(haloCompanyId),
          organization: loadCbInsightsOrganizationApi(haloCompanyId),
          people: loadCbInsightsPeopleApi(haloCompanyId),
        },
      });
      if (
        !!Object.values(cbInsights).filter((cbInsightValue) => !!cbInsightValue)
          .length
      )
        companyWithLoadedData.cbInsights = cbInsights;

      // TODO: Remove this when we have real data
      if (companyId === 'ebf2401ae39e41789cd94788216d3f43')
        companyWithLoadedData.customFinancials = {
          image: ebf2401ae39e41789cd94788216d3f43FinancialImage,
          data: ebf2401ae39e41789cd94788216d3f43FinancialJson,
        };

      return resolve(companyWithLoadedData);
    } catch (error) {
      reject(error);
    }
  });

export default getByIdApi;
